import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="editor_align_center-a" d="M5,4 L5,3 L11,3 L11,4 L5,4 Z M3,7 L3,6 L13,6 L13,7 L3,7 Z M5,10 L5,9 L11,9 L11,10 L5,10 Z M3,13 L3,12 L13,12 L13,13 L3,13 Z"/>
    </defs>
    <g>
      <use xlinkHref="#editor_align_center-a"/>
    </g>
  </svg>
);
